import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';

@Component({
  selector: 'app-export-generic',
  templateUrl: './export-generic.component.html',
  styleUrls: ['./export-generic.component.css']
})
export class ExportGenericComponent implements OnInit {

  @Input() form: UntypedFormGroup;

  constructor() {
  }

  ngOnInit(): void {
    this.form.addControl('contractStartDate', new UntypedFormControl());
    this.form.addControl('contractEndDate', new UntypedFormControl());
  }

  clearStartDateContract() {
    this.form.controls.contractStartDate.setValue('');
  }

  clearEndDateContract() {
    this.form.controls.contractEndDate.setValue('');
  }

}
